import { GET, PUT } from "./_config";

export const getSettingsApi = async () => {
  return await GET(`/settings`, true);
};
export const updateSettingApi = async (body: any) => {
  return await PUT(`/settings`, body, true);
};
